<div class="events-page">
  <div class="events-page-header">
    <h2>Events</h2>
  </div>

  @if (!loading && longTermEvents.length > 0) {
    <section class="long-term-section">
      <button type="button"
        class="long-term-toggle"
        [class.is-open]="longTermExpanded"
        [attr.aria-expanded]="longTermExpanded"
        (click)="toggleLongTermEvents()">
        <span class="long-term-title">
          <span class="section-kicker">Saison</span>
          <span class="long-term-heading">Langzeit-Tipps</span>
        </span>
        <span class="long-term-meta">
          <span class="section-count">{{ longTermEvents.length }}</span>
          @if (!longTermExpanded) {
            <i class="bi bi-chevron-down"></i>
          }
          @if (longTermExpanded) {
            <i class="bi bi-chevron-up"></i>
          }
        </span>
      </button>
      @if (longTermExpanded) {
        <div class="long-term-content event-card-grid">
          @for (event of longTermEvents; track event) {
            <app-event-card [event]="event"></app-event-card>
          }
        </div>
      }
    </section>
  }

  @if (!loading) {
    <section class="normal-events-section">
      <div class="normal-events-header">
        <div>
          <span class="section-kicker">Events</span>
          <h3>Reguläre Events</h3>
        </div>
        <div class="league-filter-group" aria-label="Liga filtern">
          <input type="radio" class="btn-check" name="league-filter" id="all-outlined" autocomplete="off" checked
            [formControl]="leagueControl" value="ALL">
          <label class="btn btn-outline-danger" for="all-outlined">Alle</label>
          <input type="radio" class="btn-check" name="league-filter" id="wwe-outlined" autocomplete="off"
            [formControl]="leagueControl" value="WWE">
          <label class="btn btn-outline-danger" for="wwe-outlined">WWE</label>
          <input type="radio" class="btn-check" name="league-filter" id="nxt-outlined" autocomplete="off"
            [formControl]="leagueControl" value="NXT">
          <label class="btn btn-outline-danger" for="nxt-outlined">NXT</label>
          <input type="radio" class="btn-check" name="league-filter" id="aew-outlined" autocomplete="off"
            [formControl]="leagueControl" value="AEW">
          <label class="btn btn-outline-danger" for="aew-outlined">AEW</label>
        </div>
      </div>
      <div class="event-card-grid">
        @for (event of filteredEvents; track event) {
          <app-event-card [event]="event"></app-event-card>
        }
      </div>
    </section>
  }

  @if (loading) {
    <div class="event-card-grid">
      @for (_ of [].constructor(3); track _) {
        <div class="card skeleton-card">
          <div>
            <div class="skeleton-image">
              <ngx-skeleton-loader
                count="1"
                appearance="circle"
            [theme]="{
              width: '340px',
              height: '300px',
              'border-radius': '10px',
              margin: 'auto'
            }">
              </ngx-skeleton-loader>
            </div>
            <div class="card-body">
              <h5 class="card-title">
                <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
              </h5>
              <p class="card-text">
                <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
              </p>
              <p class="card-text">
                <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
